"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requires2FA = void 0;
const requires2FA = (roles, flags) => {
    if (roles.includes('ADMIN') && flags.admin2fa)
        return true;
    if (roles.includes('STAFF') && flags.staff2fa)
        return true;
    if (roles.includes('REFERRAL_PARTNER') && flags.referralPartner2fa)
        return true;
    if (flags.all2fa)
        return true;
    return false;
};
exports.requires2FA = requires2FA;
